import React from 'react';
import PropTypes from 'prop-types';
import Label from '../Label';
import specialRegions from '../options';

import useStyles from '../../makeStyles';

const SuggestedCountries = ({
  suggestedCountries,
  selectedDestinations,
  handleDestinationChange,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.suggestions}>
      {suggestedCountries.map((suggestion) => {
        const isSelectedFromSuggested = selectedDestinations.includes(suggestion);
        const isSelected = selectedDestinations.some(
          (selected) => selected.code === suggestion.code,
        );

        return (
          <div
            key={suggestion.id}
            className={
              isSelectedFromSuggested || isSelected
                ? classes.suggestedSelectedCountry
                : classes.suggestedCountry
            }
            role="presentation"
            onClick={() => handleDestinationChange(suggestion)}
          >
            <Label option={suggestion} specialRegions={specialRegions} />
          </div>
        );
      })}
    </div>
  );
};

SuggestedCountries.propTypes = {
  selectedDestinations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  suggestedCountries: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleDestinationChange: PropTypes.func.isRequired,
};

export default SuggestedCountries;
